module.exports = __webpack_public_path__ + "static/media/signage-industrial-img25.f692054b.jpg";